module.exports = __webpack_public_path__ + "static/generalUsageYes-6f40e048f3f44d144e4839e828cc58b6.png";